import React, { useContext, useEffect, useState } from 'react'
import { Row, Card, Select } from 'antd';
import { RootStoreContext } from '../../app/stores/rootStore';
import FeatureHeading from '../../app/components/headings/FeatureHeading';
import { ICompany } from '../../app/models/company';
import Role from '../../app/models/role';
import OnTimeReport from './components/OnTimeReport';
import PodReport from './components/PodReport';

const InsightsHome = () => {
	const rootStore = useContext(RootStoreContext);
	const { user } = rootStore.userStore;
	const { getCompanies } = rootStore.companyStore;

	const [companies, setCompanies] = useState<ICompany[]>();
	const [selectedCompany, setSelectedCompany] = useState<ICompany>();
	const [loadingCompanies, setLoadingCompanies] = useState(false);

	const onCompanyChange = async (value: string) => {
		setSelectedCompany(companies?.find(x => x.id === value)!)
	}

	useEffect(() => {
		if (user?.role === Role.user) {
			setCompanies([user.company]);
			setSelectedCompany(user.company);
			return;
		}
		setLoadingCompanies(true);
		getCompanies({ limit: -1, orderByColumn: 'CompanyName' })
			.then(companies => {
				setCompanies(companies.data);
				setSelectedCompany(user!.company);
			})
			.finally(() => setLoadingCompanies(false));
	}, [getCompanies, user])

	return (
		<>
			<FeatureHeading value='Insights' />
			<Card>
				<Row style={{ paddingBottom: '3px' }}>
					<Select
						virtual={false}
						placeholder='select a company'
						loading={loadingCompanies}
						showSearch
						disabled={companies?.length === 1}
						filterOption={(input, option) =>
							option?.props.title?.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						value={selectedCompany?.id}
						onChange={value => onCompanyChange(value)}
						style={{ width: '200px' }}
					>
						{companies?.map(company => {
							return (<Select.Option key={company.id} value={company.id} title={company.companyName}>{company.companyName}</Select.Option>)
						})}
					</Select>
				</Row>
				{selectedCompany && (
					<>
						<OnTimeReport
							company={selectedCompany}
						/>
						<PodReport
							company={selectedCompany}
						/>
					</>
				)}
			</Card>
		</>
	)
}

export default InsightsHome
